import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Dropdown from 'flarum/common/components/Dropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import { staffQuery } from './utils/staffGroups';
import { onlineQuery } from './query/OnlineGambit';
import { memberListView } from './utils/memberListView';

// The member list - fof/user-directory's /users page, shown as a list by
// addMemberList.tsx. Only for those allowed to see it (members, not
// guests), and only while that extension is there: its route is looked up
// at runtime.
function canViewMemberList() {
  return 'fof_user_directory' in app.routes && !!app.forum.attribute('canViewUserDirectory');
}
function trans(key) {
  return app.translator.trans(`champis-users.forum.members_menu.${key}`);
}

/**
 * "Membres" in the header's right-hand part: the members online now, the
 * member list and the team, as phpBB's header linked them. An icon alone from tablet up, like the
 * notifications next to it (.ChampisHeaderIconMenu, champis-theme), with
 * its label in the phone's drawer menu. Priority 23: after "Règles et
 * aide" (26) and champis-species' "Espèces" (24), before the private
 * messages and flags (15).
 */
export default function addMembersMenu() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    if (!canViewMemberList()) return;

    // Set, not left to LinkButton: it compares the path alone, the same
    // /users for all three - see memberListView().
    const view = memberListView();
    items.add('champisMembersMenu', m(Dropdown, {
      className: "ChampisHeaderIconMenu",
      buttonClassName: "Button Button--link",
      menuClassName: "Dropdown-menu--right",
      icon: "fas fa-users",
      label: trans('label')
      // The browser's own tooltip - Flarum's (the tooltip attr) stays
      // over the menu once it opens.
      ,
      buttonAttrs: {
        title: trans('label')
      },
      accessibleToggleLabel: trans('toggle_accessible_label')
    }, m(LinkButton, {
      className: "ChampisMembersMenu-online",
      icon: "fas fa-circle",
      href: app.route('fof_user_directory', {
        q: onlineQuery()
      }),
      active: view === 'online'
    }, trans('online_link')), m(LinkButton, {
      icon: "fas fa-list",
      href: app.route('fof_user_directory'),
      active: view === 'members'
    }, trans('members_link')), m(LinkButton, {
      icon: "fas fa-user-shield",
      href: app.route('fof_user_directory', {
        q: staffQuery()
      }),
      active: view === 'team'
    }, trans('team_link'))), 23);
  });
}